import {pickAll} from 'ramda'
import {ProviderRequestType} from 'types/providerInfo'
import {UrlCheckoutParamsType} from '@daedalus/core/src/utils/url/types/UrlParams'

export const getDefaultParams = pickAll<
  UrlCheckoutParamsType,
  ProviderRequestType
>(['providerCode', 'countryCode'])

export default getDefaultParams
